import OrderableModel from '@/models/OrderableModel';
import store from '@/store';

export default class AssetStatus extends OrderableModel {
    get route () {
        return 'asset-statuses';
    }

    static get className () {
        return 'AssetStatus';
    }

    static get isInStore () {
        return true;
    }

    static getIdByType (type) {
        const types = {
            quoted: 1,
            ordered: 2,
            instock: 3,
            active: 4,
            inactive: 5,
        };

        const status = store.getters.getFilteredValue('assetStatuses', (status) => {
            return status.internal_type === types[type];
        });

        return status ? status.id : null;
    }
}
